import React from 'react';
import DashboardLayout from "../../../layouts/DashboardLayout";
import UpgradeBusinessPlus from "../../../components/UpgradeBusinessPlus";

function PaymentGatewayCreate() {
	return (
		<DashboardLayout>
			<UpgradeBusinessPlus/>
		</DashboardLayout>
	);
}

export default PaymentGatewayCreate;